import { Helmet } from 'react-helmet';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmailIcon from '@mui/icons-material/Email';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import WavingHandIcon from '@mui/icons-material/WavingHand';

export function Home() {
  const theme = useTheme();
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://techcareer.io/" />
      </Helmet>
      <Grid
        container
        direction="column"
        spacing={4}
        sx={{
          marginTop: theme.spacing(4),
        }}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid
            size={1}
            container
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <WavingHandIcon
              sx={{
                fontSize: 64,
              }}
            />
          </Grid>
          <Grid size={8}>
            <Typography>
              We are a career coaching company for people working in the tech
              industry and people who want to start a new career in the tech
              industry. We provide 1:1 (one-on-one) coaching services with
              industry veterans. We also arrange small group programs from time
              to time. We are here to help you kickstart and grow your tech
              career!
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid
            size={1}
            container
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <SwitchAccountIcon
              sx={{
                fontSize: 64,
              }}
            />
          </Grid>
          <Grid size={8}>
            <Typography variant="h4" component="h2">
              Coaches
            </Typography>
            <Grid container alignItems="stretch" spacing={2}>
              <Grid size={4} container>
                <Card>
                  <CardHeader
                    avatar={
                      <Avatar alt="Cat Chen" src="/coaches/catchen.jpg" />
                    }
                    title="Cat Chen"
                    subheader="Author, speaker, coach"
                  />
                  <CardContent>
                    <Typography variant="body2" component="p">
                      Cat Chen worked as engineer and/or manager at Chime,
                      Robinhood, Facebook, Wandou Labs, Yahoo and Baidu.
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      color="primary"
                      variant="contained"
                      startIcon={<EmailIcon />}
                      href="mailto:catchen@techcareer.io?subject=Career%20Coaching%20Inquiry"
                    >
                      Email
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      startIcon={<CalendarMonthIcon />}
                      href="https://cal.com/catchen"
                    >
                      Schedule
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid size={4} container>
                <Card>
                  <CardHeader
                    avatar={<Avatar alt="Wilson Ng">WN</Avatar>}
                    title="Wilson Ng"
                    subheader="ACM ICPC medalist"
                  />
                  <CardContent>
                    <Typography variant="body2" component="p">
                      Wilson Ng is a staff software engineer at one of the FAANG
                      company.
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      color="primary"
                      variant="contained"
                      startIcon={<EventBusyIcon />}
                      disabled
                    >
                      Not Available
                    </Button>
                  </CardActions>
                </Card>
              </Grid>{' '}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <Grid
            size={1}
            container
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <LibraryBooksIcon
              sx={{
                fontSize: 64,
              }}
            />
          </Grid>
          <Grid size={8}>
            <Typography variant="h4" component="h2">
              Programs
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
